export interface WithdrawalRejectRequestResponse {
  success_amount: number;
  fail_amount: number;
}

export interface WithdrawalRejectState {
  amount?: number;
  currency?: string;
  isOpened: boolean;
  closeTrigger: number;
  isFetching: boolean;
  response?: WithdrawalRejectRequestResponse;
}

export enum WithdrawalRejectRequestStatus {
  success,
  failed,
}
